let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jP2nA")).then(() => parcelRequire('eb65P'));